import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { resetPassword } from '../services/operations/authApi';
import { BsArrowLeft } from 'react-icons/bs';
import { useForm } from 'react-hook-form';
import PasswordValidator from '../components/common/PasswordValidator';
import ConfirmationModal from '../components/common/ConfirmationModal';

const UpdatePassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token } = useParams();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmationModal, setConfirmationModal] = useState(null);
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();
    const handleOnSubmit = (data) => {
        if (data.password !== data.confirmPassword) {
            setConfirmationModal({
                text1: 'Password Mismatch ❗️',
                text2: 'The password and confirm password entries do not match. Please ensure they are identical and try again.',
                closeModal: () => setConfirmationModal(null),
            })
            return;
        }
        dispatch(resetPassword(data.password, data.confirmPassword, token, navigate, setConfirmationModal));
    };

    return (
        <div className='mt-14'>
            <div className='flex justify-center items-center relative md:top-[5rem]'>
                <div className='text-richblack-5 w-[30rem] h-[44rem] p-[2rem]'>
                    <h1 className='text-3xl font-semibold my-3'>Create New Password</h1>
                    <p className='text-lg text-richblack-100 my-3'>Almost done. Enter your new password and you're all set.</p>
                    <form onSubmit={handleSubmit(handleOnSubmit)} className='flex flex-col my-3'>
                        <div className='flex gap-x-4 flex-col'>
                            <label className='relative mb-6'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Create Password <sup className='text-pink-200'>*</sup></p>
                                <input
                                    className='w-full p-[12px] pr-10 bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none mt-1'
                                    style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                    type={showPassword ? 'text' : 'password'}
                                    name='password'
                                    placeholder='Create Password'
                                    {...register('password', {
                                        required: true,
                                        onChange: handlePasswordChange,
                                        value: password,
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-])[^ ]{8,}$/,
                                            message: 'Must meet all validation criteria',
                                        },
                                    })}
                                />
                                {errors.password && (<span className='text-pink-200 text-sm'>Please Enter Password</span>)}

                                <span className='absolute right-3 top-[38px] z-[10] cursor-pointer text-2xl text-richblack-100' onClick={() => showPassword ? setShowPassword(false) : setShowPassword(true)}>{showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}</span>
                            </label>
                            <label className='relative mb-2'>
                                <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Confirm Password <sup className='text-pink-200'>*</sup></p>
                                <input
                                    className='w-full p-[12px] pr-10 bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none mt-1'
                                    style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    name='confirmPassword'
                                    placeholder='Confirm Password'
                                    {...register('confirmPassword', { required: true })}
                                />
                                {errors.confirmPassword && (<span className='text-pink-200 text-sm'>Please Enter Confirm Password</span>)}

                                <span className='absolute right-3 top-[38px] z-[10] cursor-pointer text-2xl text-richblack-100' onClick={() => showConfirmPassword ? setShowConfirmPassword(false) : setShowConfirmPassword(true)}>{showConfirmPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}</span>
                            </label>
                        </div>
                        <PasswordValidator password={password} />
                        <div>
                            <button type='submit' className='w-full font-bold shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] text-[17px] px-6 py-3 rounded-md bg-yellow-50 text-black hover:shadow-transparent hover:scale-95 transition-all duration-200 my-5'> Reset Password</button>
                        </div>
                        <div className='mx-5'>
                            <Link to={'/login'}>
                                <p className='flex items-center gap-2'><span><BsArrowLeft /></span>Back to Login</p>
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    )
}

export default UpdatePassword